import { useDispatch, useSelector } from "react-redux";
import { Button, addToCart } from "@ten24/slatwall-storefront-react-private/global";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { AddProductToQuoteModal } from "../ProductDetail/AddProductToQuoteModal";

const AuthenticateRequiredMessage = () => {
  const { t } = useTranslation();
  return (
    <div className="alert alert-warning fs-6" role="alert">
      {t("frontend.product.loginToAdd")}
      <br />
      <Link to="/my-account/login"> {t("frontend.account.login")} </Link>
    </div>
  );
};

const QuoteButton = ({ skuSettings, isFetching, skuID, listingButtonLabel }) => {
  const [quoteModal, setQuoteModal] = useState(false);

  return (
    <>
      <Button
        classList="btn btn-primary atq-button"
        disabled={
          isFetching || (typeof skuSettings?.skuAllowQuoteFlag === "boolean" && !skuSettings?.skuAllowQuoteFlag)
        }
        label={listingButtonLabel}
        onClick={(e) => {
          e.preventDefault();
          setQuoteModal(true);
        }}
      />
      {quoteModal && <AddProductToQuoteModal show skuID={skuID || ""} quantity="1" setQuoteModal={setQuoteModal} />}
    </>
  );
};

const ProductCardButton = ({
  skuSettings,
  productLink,
  isFetching,
  skuID,
  itemCount,
  setFetching,
  setItemCount,
  shouldDisplayAuthenticationRequiredMessageFlag = false,
  disableListingButton = false,
  type = "ADD_TO_CART",
  listingButtonLabel,
}) => {
  const dispatch = useDispatch();

  const siteSetting = useSelector((state) => state.configuration.site.settings);

  if (type === "VIEW") {
    return (
      <Link to={productLink} className="btn btn-primary">
        {listingButtonLabel}
      </Link>
    );
  }

  if (type === "ADD_TO_CART" && siteSetting.sitePurpose !== "Non-Transactional") {
    if (shouldDisplayAuthenticationRequiredMessageFlag) return <AuthenticateRequiredMessage />;
    return (
      <Button
        disabled={isFetching || disableListingButton}
        isLoading={isFetching}
        classList="btn btn-primary atc-button"
        label={listingButtonLabel}
        onClick={(e) => {
          e.preventDefault();
          setFetching(true);
          dispatch(addToCart(skuID, itemCount)).then(() => {
            setFetching(false);
            setItemCount(1);
          });
        }}
      />
    );
  }
  if (type === "PRODUCT_ATTRIBUTE_FILE") {
    return (
      <Link to="link-to-file" className="btn btn-primary">
        Link to File
      </Link>
    );
  }

  if (type === "ADD_TO_QUOTE" && siteSetting.sitePurpose !== "Non-Transactional") {
    return (
      <QuoteButton
        skuSettings={skuSettings}
        isFetching={isFetching}
        skuID={skuID}
        listingButtonLabel={listingButtonLabel}
      />
    );
  }
  return null;
};

export default ProductCardButton;
